import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Conductor } from '@opendate-app/setlist';
import '../../styles/beautifui.css';

const formatElapsed = (tenths) => {
  const seconds = tenths / 10;
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  return `${Math.floor(seconds / 60)}m ${(seconds % 60).toFixed(1)}s`;
};

const ConductorLoadingState = ({ label = 'Thinking', animation = 'constellation-twinkle' }) => {
  const [tenths, setTenths] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setTenths((current) => current + 1), 100);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div role="status" className="bui bui-loading">
      <Conductor className="bui-loading-mark" width={18} height={18} animation={animation} />
      <span className="bui-shimmer-text">{label}</span>
      <span className="bui-elapsed">{formatElapsed(tenths)}</span>
    </div>
  );
};

ConductorLoadingState.propTypes = {
  label: PropTypes.string,
  animation: PropTypes.string
};

export default ConductorLoadingState;
